<template>
  <b-card no-body class="mb-1">
    <b-card-header header-tag="header" class="p-1" role="tab" :class="headerClass">
      <b-button block v-b-toggle="`accordion-${flightKey}`" :variant="buttonVariant" class="text-white"
        @click="expandGroup">
        Flight {{ group.data[0].attributes.flightNumber }},
        <span v-if="group.data[0].attributes.codeShare">
          <span v-for="(codeShare, index) in group.data[0].attributes.codeShare.split(', ')" :key="index">
            {{ codeShare }}
            <span v-if="index < group.data[0].attributes.codeShare.split(', ').length - 1">,</span>
          </span>
        </span>
        to {{ group.data[0].attributes.arrivalAirport }}
        <span v-if="group.data[0].attributes.estimatedGateDeparture">
          | STD {{ formatDate(group.data[0].attributes.estimatedGateDeparture) }}
        </span>
        <span v-else>
          | STD {{ formatDate(group.data[0].attributes.departureTime) }}
        </span>
        <span v-if="group.data[0].attributes.actualGateDeparture">
          | ATD {{ formatDate(group.data[0].attributes.actualGateDeparture) }}
        </span>

        | Total Guests: {{ group.data.length }} |
        Checked Guests: {{ checkedCount }} |
        OWN AIR: {{ ownAirCount }} |
        Ass.Req: {{ totalRemarks }}
      </b-button>

      <b-button class="float-right ml-1" @click.stop="openAddGuestModal" variant="success">
        <i class="fas fa-user-plus"></i>
      </b-button>
      <b-i :class="group.isEditing ? 'fas fa-save' : 'fas fa-edit'" class="float-right ml-1"
        @click.stop="toggleEditSave" style="cursor: pointer;"></b-i>

      <div class="progress mt-2">
        <i class="fas fa-plane" :style="{ left: calculatePlanePosition + '%' }"></i>
        <div class="progress-bar" role="progressbar" :style="{ width: calculateProgress + '%' }">
        </div>
      </div>
    </b-card-header>

    <b-modal :id="`add-guest-modal-${flightKey}`" title="Add New Guest" size="lg" @ok="saveNewGuest">
      <b-form>
        <b-row>
          <b-col md="4">
            <b-form-group label="Cruise Line">
              <b-form-input v-model="newGuestForm.cruiseLine"></b-form-input>
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group label="Flight Number">
              <b-form-input v-model="newGuestForm.flightNumber"></b-form-input>
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group label="Feeder">
              <b-form-input v-model="newGuestForm.feeder" placeholder="Enter feeder"></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col md="4">
            <b-form-group label="Guest Last Name">
              <b-form-input v-model="newGuestForm.guestsLastName" placeholder="Enter last name"></b-form-input>
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group label="First Name">
              <b-form-input v-model="newGuestForm.firstName" placeholder="Enter first name"></b-form-input>
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group label="Booking Number">
              <b-form-input v-model="newGuestForm.bookingNumber" placeholder="Enter booking number"></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col md="4">
            <b-form-group label="Language">
              <b-form-input v-model="newGuestForm.language" placeholder="Enter language (e.g. DEU)"></b-form-input>
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group label="Cabin Number">
              <b-form-input v-model="newGuestForm.cabinNumber" placeholder="Enter cabin number"></b-form-input>
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group label="Note">
              <b-form-input v-model="newGuestForm.note" placeholder="Enter note"></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col md="6">
            <b-form-group label="Remarks">
              <b-form-input v-model="newGuestForm.remarks" placeholder="Enter remarks"></b-form-input>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group label="Additional Info">
              <b-form-input v-model="newGuestForm.additionalInfo" placeholder="Enter additional info"></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
      </b-form>
    </b-modal>

    <b-collapse :id="`accordion-${flightKey}`" accordion="my-accordion" role="tabpanel">
      <b-card-body v-if="isExpanded">
        <div v-if="group.isEditing">
          <b-form-group label="Cruise Line">
            <b-form-input v-model="group.cruiseLine"></b-form-input>
          </b-form-group>
          <b-form-group label="Flight Number">
            <b-form-input v-model="group.flightNumber"></b-form-input>
          </b-form-group>
          <b-form-group label="Arrival Airport">
            <b-form-input v-model="group.arrivalAirport"></b-form-input>
          </b-form-group>
          <b-form-group label="Departure Date">
            <b-form-input v-model="group.departureDate" type="date"></b-form-input>
          </b-form-group>
          <b-form-group label="Arrival Date">
            <b-form-input v-model="group.arrivalDate" type="date"></b-form-input>
          </b-form-group>
          <b-form-group label="Departure Time">
            <b-form-input v-model="group.departureTime"></b-form-input>
          </b-form-group>
          <b-form-group label="Estimated Departure Time">
            <b-form-input v-model="group.estimatedGateDeparture"></b-form-input>
          </b-form-group>
          <b-form-group label="Actual Departure Time">
            <b-form-input v-model="group.actualGateDeparture"></b-form-input>
          </b-form-group>
          <b-form-group label="Status">
            <b-form-input v-model="group.status"></b-form-input>
          </b-form-group>
          <b-form-group label="Departure Terminal">
            <b-form-input v-model="group.departureTerminal"></b-form-input>
          </b-form-group>
          <b-form-group label="Departure Gate">
            <b-form-input v-model="group.departureGate"></b-form-input>
          </b-form-group>
          <b-form-group label="Baggage">
            <b-form-input v-model="group.baggage"></b-form-input>
          </b-form-group>
          <b-form-group label="Buses">
            <b-form-input v-model="group.buses"></b-form-input>
          </b-form-group>
        </div>

        <b-row v-if="!group.isEditing">
          <b-col md="4" v-for="item in sortedData" :key="item.id">
            <GuestCard :guest="item" @status-changed="updateCheckedCount" @guest-updated="$emit('data-updated')" />
          </b-col>
        </b-row>
      </b-card-body>
    </b-collapse>
  </b-card>
</template>

<script>
import GuestCard from '../shared/GuestCard.vue';
import { formatTime, formatDate, calculateDelay, calculatePlanePosition, calculateProgress } from '../../helper/flight-helpers.js';

export default {
  name: 'DebarkFlightGroup',
  components: { GuestCard },
  props: {
    group: { type: Object, required: true },
    flightKey: { type: String, required: true },
    isExpanded: { type: Boolean, default: false }
  },
  data() {
    return {
      newGuestForm: {
        cruiseLine: '',
        flightNumber: '',
        feeder: '',
        guestsLastName: '',
        firstName: '',
        bookingNumber: '',
        language: '',
        cabinNumber: '',
        note: '',
        remarks: '',
        additionalInfo: ''
      }
    };
  },
  computed: {
    sortedData() {
      return this.group.data.slice().sort((a, b) => {
        const nameA = a.attributes?.guestsLastName || '';
        const nameB = b.attributes?.guestsLastName || '';
        return nameA.localeCompare(nameB);
      });
    },
    totalPax() {
      return this.group.data.length;
    },
    checkedCount() {
      return this.group.data.filter(g => g.checked).length;
    },
    ownAirCount() {
      return this.group.data.filter(g => g.attributes.note === 'OWN AIR').length;
    },
    totalRemarks() {
      return this.group.data.filter(g => g.attributes.remarks && g.attributes.remarks.trim() !== '').length;
    },
    calculatePlanePosition() {
      const { actualRunwayDeparture, estimatedRunwayArrival } = this.group.data[0].attributes;
      return calculatePlanePosition(actualRunwayDeparture, estimatedRunwayArrival);
    },
    calculateProgress() {
      const { actualRunwayDeparture, estimatedRunwayArrival } = this.group.data[0].attributes;
      return calculateProgress(actualRunwayDeparture, estimatedRunwayArrival);
    },
    headerClass() {
      const status = this.group.data[0].attributes.status;
      const attributes = this.group.data[0].attributes;
      const actualOrEstimated = status === 'A' || status === '' ? attributes.actualGateDeparture : attributes.estimatedGateDeparture;
      const delay = parseInt(calculateDelay(actualOrEstimated, attributes.departureTime, attributes.departureDate));

      return {
        'bg-light-grey text-black': status === 'L',
        'bg-dark-grey text-black': status === 'L' && delay > 15,
        'bg-dark-blue text-black': status === 'L' && delay < 0,
        'bg-dark-red text-white': status === 'C',
        'bg-light-grey text-white': status === 'A',
        'bg-dark-grey text-white': status === 'A' && delay > 15,
        'bg-dark-blue text-white': status === 'A' && delay < 0,
        'bg-light-brown': status === 'S',
        'bg-dark-brown': status === 'S' && delay > 15
      };
    },
    buttonVariant() {
      const status = this.group.data[0].attributes.status;
      const attributes = this.group.data[0].attributes;
      const actualOrEstimated = status === 'A' || status === '' ? attributes.actualGateDeparture : attributes.estimatedGateDeparture;
      const delay = parseInt(calculateDelay(actualOrEstimated, attributes.departureTime, attributes.departureDate));
      if (status === 'L' && (!delay || delay <= 15)) return 'light-grey';
      if (status === 'L' && (!delay || delay > 15)) return 'dark-grey';
      if (status === 'C') return 'dark-red';
      if (status === 'A' && (!delay || delay <= 15)) return 'light-grey';
      if (status === 'A' && delay > 15) return 'dark-grey';
      if (status === 'A' && delay < 0) return 'dark-blue';
      if (status === 'S' && (!delay || delay <= 15)) return 'light-brown';
      if (status === 'S' && delay > 15) return 'dark-brown';
      return 'info';
    }
  },
  methods: {
    formatTime,
    formatDate,
    getGateDepartureTime(attributes) {
      const status = attributes.status;
      return status === 'A' || status === '' ? attributes.actualGateDeparture : attributes.estimatedGateDeparture;
    },
    calculateDepartureGateDelay(status, actualGateDeparture, estimatedGateDeparture, departureTime, departureDate) {
      const actualOrEstimated = status === 'A' || status === '' ? actualGateDeparture : estimatedGateDeparture;
      return calculateDelay(actualOrEstimated, departureTime, departureDate);
    },
    expandGroup() {
      this.$emit('expand', this.flightKey);
    },
    openAddGuestModal() {
      const firstAttr = this.group.data[0]?.attributes || {};
      this.newGuestForm = {
        cruiseLine: firstAttr.cruiseLine || '',
        flightNumber: firstAttr.flightNumber || '',
        feeder: '',
        guestsLastName: '',
        firstName: '',
        bookingNumber: '',
        language: '',
        cabinNumber: '',
        note: '',
        remarks: '',
        additionalInfo: '',
        guestStatus: 'Unchecked',
        arrivalDate: firstAttr.arrivalDate || null,
        departureAirport: firstAttr.departureAirport || null,
        arrivalAirport: firstAttr.arrivalAirport || null,
        departureDate: firstAttr.departureDate || null,
        departureTime: firstAttr.departureTime || null,
        arrivalTime: firstAttr.arrivalTime || null,
        estimatedGateDeparture: firstAttr.estimatedGateDeparture || null,
        actualGateDeparture: firstAttr.actualGateDeparture || null
      };
      this.$bvModal.show(`add-guest-modal-${this.flightKey}`);
    },
    async saveNewGuest(bvModalEvt) {
      if (bvModalEvt) bvModalEvt.preventDefault();

      const firstAttr = this.group.data[0]?.attributes || {};
      const shipCallId = firstAttr.shipCall?.data?.id
        || firstAttr.shipCall?.id
        || firstAttr.shipCall;

      const payload = {};
      for (const [key, val] of Object.entries(this.newGuestForm)) {
        if (val !== '' && val !== null && val !== undefined) {
          payload[key] = val;
        }
      }
      if (shipCallId) {
        payload.shipCall = shipCallId;
      }

      try {
        const response = await this.$xhr.post('/api/transfers', { data: payload });
        const createdGuest = response.data.data;
        const newGuestObj = {
          id: createdGuest.id,
          attributes: {
            ...createdGuest.attributes,
            shipCall: shipCallId ? { data: { id: shipCallId } } : undefined
          },
          checked: false,
          isEditing: false
        };
        this.group.data.push(newGuestObj);
        this.updateCheckedCount();
        this.expandGroup();
        this.$nextTick(() => {
          this.$root.$emit('bv::show::collapse', `accordion-${this.flightKey}`);
        });
        this.$bvModal.hide(`add-guest-modal-${this.flightKey}`);
      } catch (error) {
        console.error('Error adding guest via modal:', error?.response?.data || error);
      }
    },
    toggleEditSave() {
      if (this.group.isEditing) {
        this.saveFlightChanges();
      } else {
        this.editFlight();
      }
    },
    editFlight() {
      this.expandGroup();
      this.$root.$emit('bv::show::collapse', `accordion-${this.flightKey}`);
      // Store the initial state of flight details to allow editing
      this.$set(this.group, 'cruiseLine', this.group.data[0].attributes.cruiseLine);
      this.$set(this.group, 'flightNumber', this.group.data[0].attributes.flightNumber);
      this.$set(this.group, 'arrivalAirport', this.group.data[0].attributes.arrivalAirport);
      this.$set(this.group, 'departureDate', this.group.data[0].attributes.departureDate);
      this.$set(this.group, 'arrivalDate', this.group.data[0].attributes.arrivalDate);
      this.$set(this.group, 'departureTime', this.group.data[0].attributes.departureTime);
      this.$set(this.group, 'estimatedGateDeparture', this.group.data[0].attributes.estimatedGateDeparture);
      this.$set(this.group, 'actualGateDeparture', this.group.data[0].attributes.actualGateDeparture);
      this.$set(this.group, 'departureTerminal', this.group.data[0].attributes.departureTerminal);
      this.$set(this.group, 'status', this.group.data[0].attributes.status);
      this.$set(this.group, 'departureGate', this.group.data[0].attributes.departureGate);
      this.$set(this.group, 'baggage', this.group.data[0].attributes.baggage);
      this.$set(this.group, 'buses', this.group.data[0].attributes.buses);

      this.$set(this.group, 'isEditing', true);
      this.$nextTick(() => {
        this.$root.$emit('bv::toggle::collapse', `accordion-${this.flightKey}`);
      });
    },
    async saveFlightChanges() {
      const updateData = {
        cruiseLine: this.group.cruiseLine,
        flightNumber: this.group.flightNumber,
        arrivalAirport: this.group.arrivalAirport,
        arrivalDate: this.group.arrivalDate,
        departureDate: this.group.departureDate,
        departureTime: this.group.departureTime,
        estimatedGateDeparture: this.group.estimatedGateDeparture,
        actualGateDeparture: this.group.actualGateDeparture,
        departureTerminal: this.group.departureTerminal,
        status: this.group.status,
        departureGate: this.group.departureGate,
        baggage: this.group.baggage,
        buses: this.group.buses
      };

      for (const flight of this.group.data) {
        try {
          await this.$xhr.put(`/api/transfers/${flight.id}`, {
            data: updateData
          });
          Object.assign(flight.attributes, updateData); // Update the local data to reflect changes
        } catch (error) {
          console.error('Error saving flight changes:', error);
        }
      }

      this.$set(this.group, 'isEditing', false);
      this.$nextTick(() => {
        this.$root.$emit('bv::toggle::collapse', `accordion-${this.flightKey}`);
      });
    },
    updateCheckedCount() {
      this.$emit('counts-updated', this.flightKey);
    }
  }
};
</script>
